export default __webpack_public_path__ + "static/media/btn_mas_info_v.4dde9b35.png";